import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HelpCircleStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M12.0088 15.5C12.5611 15.5 13.0088 15.9477 13.0088 16.5C13.0088 17.0523 12.5611 17.5 12.0088 17.5H12C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5H12.0088Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 13.5C11.25 12.7008 11.6422 12.0397 12.0107 11.5332C12.1976 11.2763 12.4067 11.0241 12.584 10.8037C12.7692 10.5736 12.9268 10.3705 13.0527 10.1748C13.1777 9.9806 13.25 9.7499 13.25 9.5C13.25 8.80964 12.6904 8.25 12 8.25C11.3096 8.25 10.75 8.80964 10.75 9.5C10.75 9.91421 10.4142 10.25 10 10.25C9.58579 10.25 9.25 9.91421 9.25 9.5C9.25 7.98122 10.4812 6.75 12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5C14.75 10.0463 14.5896 10.5572 14.3135 10.9863C14.1406 11.255 13.9384 11.5115 13.752 11.7432C13.5577 11.9846 13.3828 12.1973 13.2236 12.416C12.9002 12.8606 12.75 13.1947 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HelpCircleStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HelpCircleStrokeIcon;
